<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      ref="pageMainRef"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @getData="getData"
        @reset="getData"
        @query="getData"
        @openAddDrawer="openAddDrawer"
      />
    </page-main>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'

export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader },
  data() {
    return {
      usePage: false,
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .sysMerchantFunctionListApi({
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openAddDrawer() {
      this.$refs.pageMainRef.openAddDrawer()
    },
    filter(keyword) {
      this.$refs.pageMainRef.filter(keyword)
    },
  },
}
</script>
